import { wsClient } from '../../util/appUtils';
import { createCloudAdminRuntime } from './cloudAdminRuntime';
import { createRuntimeSearchSettingsClient } from './runtimeSearchSettingsClient';

/**
 * Runtime-backed V2 client for non-React bootstrap code.
 *
 * React pages receive the same port from ShellAppContext. Legacy sagas cannot
 * consume React context, so this composition-root instance keeps them on the
 * identical command/transport contract instead of adding methods to wsClient.
 */
export const cloudSearchSettingsClient = createRuntimeSearchSettingsClient(
  createCloudAdminRuntime({ webserviceClient: wsClient }),
);

export default cloudSearchSettingsClient;
